module.exports = __webpack_public_path__ + "media/images/home/age-73534c63916a206cec1ecf146d247e75.png";